import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useIsMount from '@/util/hook/useIsMount.ts';
import UnifiedMap from '@/component/map/unified/UnifiedMap';
import UnifiedMarker from '@/component/map/unified/UnifiedMarker';

import { useMapType } from '@/component/map/MapContext';

interface IProps {
    className?: string;
    latitude?: number;
    longitude?: number;
}

const DefaultMap: React.FunctionComponent<IProps> = ({ className, latitude, longitude }) => {
    const { t } = useTranslation();
    const { isMount } = useIsMount();
    const mapRef = useRef<any>(null);
    const { mapType } = useMapType();
    const numericLatitude = Number(latitude);
    const numericLongitude = Number(longitude);
    const hasCoordinates = Number.isFinite(numericLatitude) && Number.isFinite(numericLongitude);

    const center = {
        lat: hasCoordinates ? numericLatitude : 37.5759,
        lng: hasCoordinates ? numericLongitude : 126.9768
    };

    useEffect(() => {
        if (mapRef.current) {
            if (mapType === 'google') {
                mapRef.current.panTo(center);
            }
        }
    }, [numericLatitude, numericLongitude, mapType]);

    const mapOptions = {
        zoom: 15,
        mapId: mapType === 'google' ? '8d4d2c95ae9b2bdf' : undefined,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false
    };

    return (
        <div className={`${className || ''} default-alert-map`} onClick={event => event.stopPropagation()}>
            {isMount && hasCoordinates ? (
                    <UnifiedMap
                        key={`${mapType}-${numericLatitude}-${numericLongitude}`}
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        center={center}
                        zoom={mapOptions.zoom}
                        options={mapOptions}
                        onLoad={(map) => {
                            mapRef.current = map;
                        }}
                    >
                        <UnifiedMarker
                            position={center}
                        />
                    </UnifiedMap>
            ) : (
                <div className="default-alert-map__empty">
                    <span>LOC</span>
                    <strong>{isMount ? t('notification.v2.defaultMap.noCoordinates') : t('notification.v2.defaultMap.preparing')}</strong>
                    <p>{isMount ? t('notification.v2.defaultMap.notReceived') : t('notification.v2.defaultMap.pleaseWait')}</p>
                </div>
            )}
        </div>
    );
};

export default DefaultMap;
